import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { PackageSearch } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    title: string
    description: string
    icon?: LucideIcon
    action?: ReactNode
    className?: string
}

export const EmptyState: FC<EmptyStateProps> = ({
    title,
    description,
    icon: Icon = PackageSearch,
    action,
    className
}): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center justify-center rounded-mta-lg border border-ink-900/10 bg-surface-muted px-6 py-20 text-center', className)}>
            <div className='flex size-12 items-center justify-center rounded-full bg-paper text-brand-red-ink'>
                <Icon className='size-6' aria-hidden='true' />
            </div>

            <h3 className='type-display mt-5 text-xl text-ink-900 sm:text-2xl'>
                {title}
            </h3>

            <p className='mt-1.5 max-w-sm text-sm text-text-muted'>
                {description}
            </p>

            {action && (
                <div className='mt-5'>
                    {action}
                </div>
            )}
        </div>
    )
}
